var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.916748C11.188 0.916748 13.2865 1.78594 14.8336 3.33312C16.3808 4.88029 17.25 6.97871 17.25 9.16675C17.25 12.5822 14.6467 16.1609 9.55 19.9834C9.39133 20.1024 9.19834 20.1667 9 20.1667C8.80166 20.1667 8.60867 20.1024 8.45 19.9834C3.35333 16.1609 0.75 12.5822 0.75 9.16675C0.75 6.97871 1.61919 4.88029 3.16637 3.33312C4.71354 1.78594 6.81196 0.916748 9 0.916748ZM9 6.41675C8.27065 6.41675 7.57118 6.70648 7.05546 7.22221C6.53973 7.73793 6.25 8.4374 6.25 9.16675C6.25 9.89609 6.53973 10.5956 7.05546 11.1113C7.57118 11.627 8.27065 11.9167 9 11.9167C9.72935 11.9167 10.4288 11.627 10.9445 11.1113C11.4603 10.5956 11.75 9.89609 11.75 9.16675C11.75 8.4374 11.4603 7.73793 10.9445 7.22221C10.4288 6.70648 9.72935 6.41675 9 6.41675Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.a48564763372400cf14394c076d06cf9.svg";
export { ForwardRef as ReactComponent };